import { BrowserRouter as Router, Switch, Route, Link} from "react-router-dom";
import logo from './logo.svg';
import '../src/assets/css/main.css';
import Home from './pages/home/Home';
import Register from './pages/Register';
import Login from './pages/login/Login';
import PostDetails from "./components/singlePost/PostDetails"
import AllPosts from "./components/allPosts/AllPosts";
import WritePost from "./pages/addPost/WritePost";
import { useContext } from "react";
import { Context } from '../src/context/Context';
import User from "./components/authors/User";
import UserSettings from "./components/settings/UserSettings";

function App() {
 const { user } = useContext(Context);

// const user = false;
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route path="/posts">
          <AllPosts />
        </Route>
        <Route path="/post/:id">
          <PostDetails />
        </Route>
        <Route path="/user">
          <User />
        </Route>
        <Route path="/settings">
          <UserSettings />
        </Route>
       <Route path="/register">
          {user ? <WritePost /> : <Register />}
        </Route> 
        <Route path="/login">
          {user ? <Home /> : <Login />}
        </Route>
      </Switch>
    </Router>
  //  <Home />
  // <Register />
  // <Login />
  );
}

export default App;
